export default [
  {
    path: '/data/clients',
    name: 'Client',
    component: () => import('@/views/admin/clients/Index.vue'),
    meta: {
      rule: 'editor',
      pageTitle: 'Clients',
      breadcrumb: [{
          title: 'Home',
          url: '/'
        },
        {
          title: 'Data'
        },
        {
          title: 'Clients',
          active: true
        },
      ],
    }
  },
  {
    path: '/data/clients/:id',
    name: 'ClientShow',
    component: () => import('@/views/admin/clients/Show.vue'),
    meta: {
      rule: 'editor',
      pageTitle: 'Projects',
      breadcrumb: [{
          title: 'Home',
          url: '/'
        },
        {
          title: 'Data'
        },
        {
          title: 'Clients',
          active: true
        },
      ],
    }
  },
]
